<!-- Loading Screen -->

@if (!isDataLoaded) {
  <div class="wrapper center"
    >
    <div class="inner-1">
      <mat-spinner> </mat-spinner>
    </div>
  </div>
}

@if (isDataLoaded) {
  <div class="container notices-container"
    >
    <!-- Heading -->
    <div class="row">
      <div class="col"
        align="left">
        <h1 i18n class="blue-heading">
             Notices
        </h1>
      </div>
      <div class="col" align="right">
        <app-menu> </app-menu>
      </div>
    </div>
    <!-- Inbox List -->
    @if (showInboxList) {
      <div>
        <mat-selection-list [multiple]="false" hideSingleSelectionIndicator>
          <div class="row">
            <div class="col">
              @if (fisheryNotices.length) {
                <h3 i18n
                  class="col blue-subheading"
                  style="padding-bottom: 5px;">
                        Mailboxes
                    </h3>
              }
              @if (!fisheryNotices.length) {
                <h3 i18n
                  class="col blue-subheading"
                  style="padding-bottom: 5px;">
                        No Notices
                    </h3>
              }
            </div>
            <div class="col"></div>
            <div class="col"
              align="right">
              <button align="right"
                mat-button
                class="back-button"
                (click)="checkForNewNotices()">
                <mat-icon>
                  refresh
                </mat-icon>
              </button>
            </div>
          </div>
          @if (!fisheryNotices.length) {
            <div i18n
              class="blue-subheading"
              style="margin-top: 10px;">
                To check for notices, please ensure you are online then press the refresh button.
             </div>
          }
          @if (fisheryNotices.length) {
            <div>
              <mat-divider></mat-divider>
              <mat-list-option (click)="inboxClick('allNotices')">
                <div class="row g-0"
                  style="padding-top: 15px;">
                  <mat-icon class="inbox-icon col">
                    inbox
                  </mat-icon>
                  <div i18n class="list-item col-11">
                            All Fishery Notices 
                            @if (getUnreadNotices('all')) {
<span>
                                ({{getUnreadNotices('all')}})
                            </span>
}
                        </div>
                </div>
              </mat-list-option>
              <mat-divider></mat-divider>
              <mat-list-option (click)="inboxClick('savedNotices')">
                <div class="row g-0"
                  style="padding-top: 15px;">
                  <mat-icon class="inbox-icon col">
                    star
                  </mat-icon>
                  <div i18n class="list-item col-11">
                            Saved Notices
                            @if (getUnreadNotices('saved')) {
<span>
                                ({{getUnreadNotices('saved')}})
                            </span>
}
                        </div>
                </div>
              </mat-list-option>
              <mat-divider></mat-divider>
              <h6 i18n class="blue-subheading"
                style="padding-bottom: 5px;">
                    Fishery-Specific Mailboxes
                </h6>
              <mat-divider></mat-divider>
              <mat-list-option (click)="inboxClick('Gill Net')">
                <div class="row g-0"
                  style="padding-top: 15px;">
                  <mat-icon class="inbox-icon col">
                    folder_outline
                  </mat-icon>
                  <div i18n class="list-item col-11">
                            Gillnet Notices
                            @if (getUnreadNotices('gill net')) {
<span>
                                ({{getUnreadNotices('gill net')}})
                            </span>
}
                        </div>
                </div>
              </mat-list-option>
              <mat-divider></mat-divider>
              <mat-list-option (click)="inboxClick('Seine')">
                <div class="row g-0"
                  style="padding-top: 15px;">
                  <mat-icon class="inbox-icon col">
                    folder
                  </mat-icon>
                  <div i18n class="list-item col-11">
                            Seine Notices 
                            @if (getUnreadNotices('seine')) {
<span>
                                ({{getUnreadNotices('seine')}})
                            </span>
}
                        </div>
                </div>
              </mat-list-option>
              <mat-divider></mat-divider>
              <mat-list-option (click)="inboxClick('Troll')">
                <div class="row g-0"
                  style="padding-top: 15px;">
                  <mat-icon class="inbox-icon col">
                    folder
                  </mat-icon>
                  <div i18n class="list-item col-11">
                            Troll Notices 
                            @if (getUnreadNotices('troll')) {
<span>
                                ({{getUnreadNotices('troll')}})
                            </span>
}
                        </div>
                </div>
              </mat-list-option>
              <mat-divider></mat-divider>
            </div>
          }
        </mat-selection-list>
      </div>
    }
    <!-- Subheading and back & refresh buttons -->
    @if (!showInboxList) {
      <div
        class="row">
        <div class="col">
          <button mat-button
            class="back-button"
            type="button"
            (click)="backToInboxList()">
            <mat-icon>
              arrow_back
            </mat-icon>
          </button>
        </div>
        @if (!showCurrNotice) {
          <h3 i18n
            class="blue-subheading col-5"
            align="center">

          {getInboxName(), select, All Notices {All Notices} Saved Notices {Saved Notices} Gill Net Notices {Gillnet Notices}  Seine Notices {Seine Notices}  Troll Notices {Troll Notices}}

        </h3>
        }
        @if (showCurrNotice) {
          <h3 i18n
            class="blue-subheading col-5"
            align="center">
            {{ currNotice.noticeNumber }}
        </h3>
        }
        <div class="col"
          align="right">
          @if (!showCurrNotice) {
            <button
              align="right"
              mat-button
              class="back-button"
              (click)="checkForNewNotices()">
              <mat-icon>
                refresh
              </mat-icon>
            </button>
          }
          @if (showCurrNotice) {
            <button
              align="right"
              mat-button
              class="back-button"
              (click)="favoriteNotice()">
              @if (!currNotice.isSaved) {
                <mat-icon class="fav-icon"
                  >
                  star_outline
                </mat-icon>
              }
              @if (currNotice.isSaved) {
                <mat-icon class="fav-icon"
                  >
                  star
                </mat-icon>
              }
            </button>
          }
        </div>
      </div>
    }
    <!-- Fishery Notices List -->
    @if (!showInboxList && !showCurrNotice) {
      <div >
        @for (notice of fisheryNotices; track notice) {
          <div>
            @if (showNotice(notice)) {
              <div
                class="notice-list row g-0">
                <div class="col button-col">
                  <button mat-button
                    (click)="favoriteNotice(notice)">
                    @if (!notice.isSaved) {
                      <mat-icon class="fav-icon"
                        >
                        star_outline
                      </mat-icon>
                    }
                    @if (notice.isSaved) {
                      <mat-icon class="fav-icon"
                        >
                        star
                      </mat-icon>
                    }
                  </button>
                </div>
                <mat-expansion-panel class="notice-items col-10"
                  hideToggle
                  disabled
                  (click)="noticeSelected(notice)">
                  <mat-expansion-panel-header>
                    <mat-panel-title>
                      <div class="row">
                        <span [class]="determineNoticeStyle(notice)">
                          {{notice.noticeNumber}}&nbsp;&nbsp;&nbsp;
                          <span class="notice-date"
                            align="left">
                            {{sharedMethodsService.getDate(notice.receivedTime) | date: 'dd/MM/yyyy'}}
                          </span>
                        </span>
                        <br>
                          <span class="subject-line">
                            {{notice.subject}}
                          </span>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                  </mat-expansion-panel>
                </div>
              }
            </div>
          }
        </div>
      }
      <!-- Individual Notice Displayed -->
      @if (showCurrNotice) {
        <div
          class="curr-notice-container">
          <div i18n class="notice-date"
            style="font-weight: bold; margin-top: 15px;">
            Date Received: {{sharedMethodsService.getDate(currNotice.receivedTime) | date: 'dd/MM/yyyy HH:mm:ss'}}
        </div>
          <div class="notice-body"
            [innerHTML]="currNotice.bodyHTML">
          </div>
        </div>
      }
      <div class="row" style="padding-top: 20px;"></div>
    </div>
  }
